import { ErrorMessageWrapper } from '@terminal/components/error-message-wrapper/ErrorMessageWrapper';
import { useQueryParams } from '@terminal/hooks/use-query-params/useQueryParams';
import { useKgInsight } from '@terminal/react-query-hooks/insights/useKgInsight';
import { queryKeys, queryValues } from '@terminal/routes/query-params';
import { FC } from 'react';
import { CompanyCatalystWidget } from '../company-catalyst-widget/CompanyCatalystWidget';
import { CatalystWidget } from './CatalystWidget';
import { KgInsightSkeleton } from './components/kg-insight-content/KgInsightSkeleton';

interface CatalystControllerProps {
  navigateToKGInsight: () => void;
  expandCitations: boolean;
}

export const CatalystController: FC<CatalystControllerProps> = ({
  navigateToKGInsight,
  expandCitations,
}) => {
  const { params } = useQueryParams();
  const insightId = params[queryKeys.insightId] ?? '';
  const isCompanyCatalystDrawer =
    params[queryKeys.activeDrawer] === queryValues.catalystInsightsDrawer;
  const { data: kgInsight, isLoading, error } = useKgInsight(insightId);

  if (isLoading) {
    return <KgInsightSkeleton />;
  }

  if (error) {
    return <ErrorMessageWrapper variant="error" />;
  }

  if (!kgInsight) {
    if (!isCompanyCatalystDrawer || !insightId) {
      return null;
    }

    return (
      <CompanyCatalystWidget
        insightId={insightId}
        expandCitations={expandCitations}
      />
    );
  }

  return <CatalystWidget navigateToKGInsight={navigateToKGInsight} />;
};
